import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// 3D coverflow carousel — centre slide large, neighbours rotated in perspective; hover pops a slide
export default function Carousel3D({ items, onSelect, interval = 3500, height = 380 }) {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const n = items.length;

  useEffect(() => {
    if (paused || n < 2) return;
    const t = setInterval(() => setIdx(i => (i + 1) % n), interval);
    return () => clearInterval(t);
  }, [paused, n, interval]);

  const go = (d) => setIdx(i => (i + d + n) % n);

  return (
    <div data-testid="carousel-3d" className="c3d-wrap" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}
      style={{ position: "relative", height, perspective: 1400, overflow: "hidden", borderRadius: 24, background: "radial-gradient(ellipse at 50% 100%, rgba(250,204,21,0.25), transparent 60%)" }}>
      {items.map((it, i) => {
        let off = i - idx;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        const abs = Math.abs(off);
        const visible = abs <= 2;
        const x = off * 46;
        const z = -abs * 220;
        const ry = -off * 32;
        return (
          <div key={i} data-testid={`carousel-slide-${i}`} onClick={() => (off === 0 ? onSelect && onSelect(it) : setIdx(i))}
            className="c3d-slide"
            style={{
              position: "absolute", left: "50%", top: "50%", aspectRatio: "16/10",
              transform: `translate(-50%, -50%) translateX(${x}%) translateZ(${z}px) rotateY(${ry}deg)`,
              opacity: visible ? 1 - abs * 0.22 : 0, zIndex: 10 - abs, cursor: off === 0 ? (onSelect ? "zoom-in" : "default") : "pointer",
              transition: "transform 700ms cubic-bezier(0.2,0.9,0.2,1), opacity 500ms",
              borderRadius: 18, overflow: "hidden", boxShadow: off === 0 ? "0 30px 60px -20px rgba(194,65,12,0.55), 0 0 0 4px #FACC15" : "0 20px 40px -20px rgba(0,0,0,0.4)",
              pointerEvents: visible ? "auto" : "none",
            }}>
            <img src={it.url} alt={it.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} loading="lazy" />
            <div style={{ position: "absolute", inset: 0, background: off === 0 ? "linear-gradient(180deg, transparent 55%, rgba(124,45,18,0.85))" : "rgba(124,45,18,0.35)" }} />
            {off === 0 && (
              <div style={{ position: "absolute", left: 18, right: 18, bottom: 14, color: "#fff" }}>
                <div style={{ fontSize: 10.5, letterSpacing: 1.5, fontWeight: 800, color: "#FDE047" }}>{(it.category || "").toUpperCase()}</div>
                <div style={{ fontSize: 17, fontWeight: 700 }}>{it.title}</div>
              </div>
            )}
          </div>
        );
      })}
      <button data-testid="carousel-prev" onClick={() => go(-1)} aria-label="Previous" className="c3d-nav" style={{ left: 14 }}><ChevronLeft size={20} /></button>
      <button data-testid="carousel-next" onClick={() => go(1)} aria-label="Next" className="c3d-nav" style={{ right: 14 }}><ChevronRight size={20} /></button>
      <div style={{ position: "absolute", bottom: 10, left: 0, right: 0, display: "flex", justifyContent: "center", gap: 6 }}>
        {items.map((_, i) => <span key={i} onClick={() => setIdx(i)} style={{ width: i === idx ? 22 : 8, height: 8, borderRadius: 4, background: i === idx ? "#F97316" : "rgba(249,115,22,0.35)", transition: "width 300ms", cursor: "pointer" }} />)}
      </div>
      <style>{`
        .c3d-slide { width: min(56%, 620px); }
        .c3d-slide:hover { filter: brightness(1.08); }
        @media (max-width: 640px) { .c3d-wrap { height: 250px !important; border-radius: 14px !important; } .c3d-slide { width: 78%; } .c3d-nav { width: 36px; height: 36px; } }
        .c3d-nav { position: absolute; top: 50%; transform: translateY(-50%); z-index: 20; width: 44px; height: 44px; border-radius: 50%; border: none; cursor: pointer; color: #fff; background: linear-gradient(180deg,#FB923C,#EA580C); box-shadow: 0 8px 18px -6px rgba(194,65,12,0.6); display: flex; align-items: center; justify-content: center; transition: transform 200ms; }
        .c3d-nav:hover { transform: translateY(-50%) scale(1.1); }
      `}</style>
    </div>
  );
}
